<template>
    <div>
        <div v-if="loading" class="loader"></div>
        <div v-else>
            <div class="mb-2">
                <button class="btn btn-primary" @click="onPdfClick">
                    <i class="far fa-file-pdf text-danger"></i>
                    {{ $t('buttons.pdfExport.tooltipText') }}
                </button>
            </div>
            <kendo-hierarchicaldatasource ref="remoteDataSourceComponent"
                                          :data="diagramData"
                                          :schema-model-children="'items'">
            </kendo-hierarchicaldatasource>

            <!--"down" - tree layout and layered layout specific subtype. In the tree layout the root is arranged at the top and its children downwards. For the layered layout the links are directed downwards. This is the default subtype.

            "up" - tree layout and layered layout specific subtype. In the tree layout the root is arranged at the bottom and its children upwards. For the layered layout the links are directed upwards.

            "left" - tree layout layered layout specific subtype. In the tree layout the root is arranged at the left and its children sideways to the right. For the layered layout the links are directed to the left.
            "right" - tree layout layered layout specific subtype. In the tree layout the root is arranged at the right and its children sideways to the left. For the layered layout the links are directed downwards.

            "mindmapHorizontal" - tree layout specific subtype. The root sits at the center and its children are spread equally to the left and right.

            "mindmapVertical" - tree layout specific subtype. The root sits at the center and its children are spread equally above and below.

            "radial" - tree layout specific subtype. The root sits at the center and its children are spread radially around.

            "tipOver" - tree layout specific subtype. A special version of the tree-down layout where the grand-children (and iteratively) are arranged vertically while the direct children are arranged horizontally. This arrangement has the advantage that it doesn't spread as much as the classic tree-down layout. See below for a concrete example.

            "horizontal" - layered layout specific subtype. The preferred direction of the links is horizontal.

            "vertical" - layered layout specific subtype. The preferred direction of the links is vertical.-->

            <div class="diagram-wrapper">
                <kendo-diagram ref="diagram1"
                               :data-source-ref="'remoteDataSourceComponent'"
                               :layout-type="'tree'"
                               :layout-subtype="'right'"
                               :editable="false"
                               :zoom="1.2"
                               :shape-defaults-visual="visualTemplate"
                               :connection-defaults-stroke-color="'#979797'"
                               :connection-defaults-stroke-width="2"
                               @kendowidgetready="kendowidgetready">
                </kendo-diagram>
            </div>
        </div>
    </div>

</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import { DiagramInstaller } from '@progress/kendo-diagram-vue-wrapper'
    import { Culture } from '../../../models/enums';

    Vue.use(DiagramInstaller)


    export default {
        components: {

        },
        props: {

        },
        data() {
            return {
                loading: false,
                diagramModel: {
                    children: 'items'
                },
                diagramData: []
            }
        },
        methods: {
            loadData() {
                this.loading = true;

                this.$http.get(`/api/employee/organogramData`)
                    .then(result => {
                        if (result.data) {
                            this.diagramData = result.data;
                        }

                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t(
                                'request.response.status.' +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            kendowidgetready: function (widget) {
                /*
               Renders the grid in "DejaVu Sans" font family, which is
               declared in kendo.common.css. It also declares the paths to the
               fonts below using <tt>kendo.pdf.defineFont</tt>, because the
               stylesheet is hosted on a different domain.
               */
                kendo.pdf.defineFont({
                    "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
                    "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
                    "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
                    "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
                    "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
                });
                widget.bringIntoView(widget.shapes)
            },
            visualTemplate: function (options) {
                var dataviz = kendo.dataviz
                var g = new dataviz.diagram.Group()
                var dataItem = options.dataItem

                g.append(new dataviz.diagram.Rectangle({
                    width: 500,
                    height: 105,
                    stroke: {
                        width: 0
                    },
                    fill: {
                        gradient: {
                            type: 'linear',
                            stops: [{
                                color: dataItem.colorScheme,
                                offset: 0,
                                opacity: 0.5
                            }, {
                                color: dataItem.colorScheme,
                                offset: 1,
                                opacity: 1
                            }]
                        }
                    }
                }))

                g.append(new dataviz.diagram.TextBlock({
                    text: dataItem.name,
                    fontSize: 16,
                    fontStyle: 'italic',
                    fontWeight: 'bold',
                    x: 85,
                    y: 20,
                    fill: '#fff'
                }))

                g.append(new dataviz.diagram.TextBlock({
                    text: dataItem.directorate,
                    x: 85,
                    y: 50,
                    fill: '#fff'
                }))

                // g.append(new dataviz.diagram.TextBlock({
                //     text: dataItem.position,
                //     x: 85,
                //     y: 70,
                //     fill: '#fff'
                // }))

                //g.append(new dataviz.diagram.Image({
                //    source: 'https://demos.telerik.com/kendo-ui/content/dataviz/diagram/people/' + dataItem.image,
                //    x: 3,
                //    y: 3,
                //    width: 68,
                //    height: 68
                //}))

                return g
            },
            onPdfClick: function (ev) {
                var diagram = this.$refs.diagram1.kendoWidget();
                diagram.saveAsPDF();
            },
            resize(){

            }
        },
        mounted() {
            this.loadData();

        },
        beforeDestroy() {
            //remove listener
        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        },
    }
</script>

<style scoped>
</style>
